import { forwardRef } from 'react';

import { TextInput } from './TextInput';
import type { TextInputProps } from './TextInput';

export interface TextAreaInputProps extends Omit<TextInputProps, 'type' | 'multiline' | 'clearable' | 'onClear'> {
  minRows?: number;
  maxRows?: number;
}

export const TextAreaInput = forwardRef<HTMLDivElement, TextAreaInputProps>(function TextAreaInput({ minRows = 3, maxRows, ...rest }, ref) {
  return <TextInput ref={ref} multiline minRows={minRows} maxRows={maxRows} {...rest} />;
});
